import axios from "axios";

import { GeocodingResponse } from "@/types/api/residence.types";

export const ResidenceService = {
  getResidence: async (params: { search: string }, signal: AbortSignal) => {
    const response = await axios.get<GeocodingResponse>(`/api/residence`, {
      params,
      signal,
    });

    return response.data;
  },
};
